import { useLogisticFilialsFilters } from 'hooks/useLogisticFilialsFilters'
import { logisticFilialsApi } from 'redux/services/logistic-filial'

import { AppStatistics } from 'components/AppStatistics/AppStatistics'

export function Statistics() {
  const { params } = useLogisticFilialsFilters()

  const { data, isSuccess } =
    logisticFilialsApi.useLogisticFilialStatisticsQuery(params)

  if (isSuccess) {
    return <AppStatistics list={data} />
  }
  return null
}
